import axios from 'axios';

const { REACT_APP_BASE_URL } = process.env;

// Fake Test
// const tokenTest = async () => {
//     return axios.get(REACT_APP_BASE_URL + 'rest/v1/auth/set-cookie-test', {
//         withCredentials: true,
//     });
// }

const loginEDevlet = async () => {
    return axios.get(REACT_APP_BASE_URL + 'rest/v1/auth/login/edevlet', {
        withCredentials: true,
    });
};

const logout = async (token : string) => {
    return axios.get(REACT_APP_BASE_URL + 'rest/v1/auth/logout', {
        withCredentials: true, params: { token }
    });
};

export const LoginRestApi = {
    loginEDevlet,
    logout,
    // tokenTest
};
